import PlanCardInner from './PlanCardInner'

export default PlanCardInner
